export const MAX_POST_LENGTH = 300;
export const MAX_COMMENT_LENGTH = 100;

export const NUMBER_OF_POSTS_PER_SCROLL = 2;

export const NOTIFICATION_TYPES = {
    FRIEND_REQUEST: "friendRequest",
    NEW_POST_ON_WALL: "newPost",
    NEW_COMMENT_ON_POST: "newComment",
    TAGGED_ON_POST: "tagged",
}